import { useEffect, useMemo, useState } from "react";
import { Activities } from "../../types/UserActivityInterfaces";
import ActivityMessage, { pageTypeIconMap } from "./ActivityMessage";
import MutedMessage from "./MutedMessage";

interface UserActivityItemInterface {
  workspaceID: string;
  workspaceActivities: Activities[];
}

const UserActivityItem = ({
  workspaceID,
  workspaceActivities,
}: UserActivityItemInterface) => {
  const [itemsShown, setItemsShown] = useState<{ [key: string]: number }>({});

  const activities = useMemo(() => {
    if (Array.isArray(workspaceActivities) && workspaceActivities?.length > 0) {
      return workspaceActivities.slice().reverse();
    }
    return [];
  }, [workspaceActivities]);

  useEffect(() => {
    if (itemsShown.hasOwnProperty(workspaceID)) return;

    setItemsShown((prev) => ({ ...prev, [workspaceID]: 6 }));
  }, [workspaceID]);

  const itemsToShow = itemsShown.hasOwnProperty(workspaceID)
    ? itemsShown[workspaceID]
    : 6;

  return (
    <div className="mx-0 mx-sm-2">
      {activities.length > 0 ? (
        <div className="mx-2 mx-sm-3">
          {activities
            .slice(
              0,
              itemsToShow > activities.length ? activities.length : itemsToShow
            )
            .map((activity: Activities) => {
              let backupIcon;

              if (activity.Type !== "edited-page") {
                backupIcon = pageTypeIconMap[activity?.View?.Type];
              }

              return (
                <div
                  key={activity.id}
                  className="d-flex align-items-center mb-4"
                >
                  <div className="mr-2">
                    {activity.Page.CloudAppLogo ? (
                      <img
                        style={{
                          width: 25,
                          height: 25,
                          borderRadius: 2,
                          border: "1px solid var(--superlight)",
                        }}
                        src={activity.Page.CloudAppLogo}
                        alt="cloud-app-icon"
                      />
                    ) : (
                      <>
                        <i
                          className={`${
                            backupIcon
                              ? `mdi mdi-${backupIcon}`
                              : "mdi mdi-file-table-box-outline"
                          }`}
                          style={{
                            fontSize: 25,
                            border: "1px solid transparent",
                            lineHeight: 1,
                            color: "var(--dark)",
                          }}
                        ></i>
                      </>
                    )}
                  </div>
                  <div className="font-weight-500 text-dark">
                    <ActivityMessage
                      activity={activity}
                      workspaceID={workspaceID}
                    />
                    <MutedMessage
                      activityType={activity.Type}
                      activityTime={activity.Time}
                    />
                  </div>
                </div>
              );
            })}
        </div>
      ) : (
        <div className="d-flex justify-content-center py-4">
          No user activity has been record yet for this workspace.
        </div>
      )}

      <div className="d-flex justify-content-center">
        {itemsToShow < activities.length && (
          <small
            onClick={() =>
              setItemsShown((prev) => {
                const copy = { ...prev };
                copy[workspaceID] += 5;
                return copy;
              })
            }
            className="text-primary cursor-pointer text-small font-weight-500"
          >
            Show more
          </small>
        )}
      </div>
    </div>
  );
};

export default UserActivityItem;
